import { Component } from "@angular/core";
import { CognitoCallback, LoggedInCallback } from "../../../providers/cognito.service";
import { AlertController, NavController, NavParams, LoadingController, Platform, IonicPage } from "ionic-angular";
import { UserLoginService } from "../../../providers/userLogin.service";
import { EventsService } from "../../../providers/events.service";
import { ProjectHomePage } from '../../project-home/project-home';
import { ConfirmRegistrationComponent } from "../confirm-registration/confirmRegistration.component";
import { ForgotPasswordStep1Component } from "../forgot-password/forgotPassword1.component";
import { AuthenticationService } from "../../../services/congito";
import { Session } from 'meteor/session'
import { SharedService } from "../../../services/sharedService";
import { HttpService } from "../../../services/httpService";
import { Router } from '@angular/router';
import { CompanyService } from "../../../services/companyData";

let urlParams:any = new URLSearchParams(window.location.search);

@Component({
    templateUrl: 'login.html'
})

export class LoginComponent implements CognitoCallback, LoggedInCallback {
    email: string;
    password: string;
    redirectUrl: string = 'https://logit-mobile.aegis-software-support.com';  // The URL of the mobile site
    desktopPlatformStringName: string = 'core'; // Will need to be changed to 'desktop', when Ionic is upgraded to v4+

    constructor(
        private sharedService: SharedService,
        public nav: NavController,
        public navParam: NavParams,
        public alertCtrl: AlertController,
        private platform: Platform,
        public userService: UserLoginService,
        public eventService: EventsService,
        private loadingCtrl: LoadingController,
        public httpService: HttpService,
        private companyDataService: CompanyService,
        public authService: AuthenticationService,
        private router: Router) {

        console.log("LoginComponent constructor");

    if (navParam != null && navParam.get("email") != null)
            this.email = navParam.get("email");

    }

    ngOnInit(): void {

      // Detect if we are on mobile
      if ( !this.platform.is (this.desktopPlatformStringName) ) { 

        // Load the mobile site. This has to be done abruptly, the Angular Router can't do it, and in Ionic v3 Nav it looks really tricky
        window.location.href = this.redirectUrl;
      }

      // Detect whether we are using the Chrome browser
      // From https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618
      //var isChromium = window.chrome;
      var winNav = window.navigator;
      var vendorName = winNav.vendor;
      //var isOpera = typeof window.opr !== "undefined";
      var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
      var isIOSChrome = winNav.userAgent.match("CriOS");

      if (isIOSChrome) {
         console.log ("This is Chrome on iOS");
      } else if(
        //isChromium !== null &&
        //typeof isChromium !== "undefined" &&
        vendorName === "Google Inc." &&
        //isOpera === false &&
        isIEedge === false
      ) {
        console.log("This is Chrome");
      } else { 
        console.log("This is not Chrome");

        this.doAlert( 
          "Please use Chrome", 
          "Logit is optimized to run on the Google Chrome browser, available at https://www.google.com/chrome/" 
          );
      }

      if(!this.email && !this.password && urlParams.get('strategy')=="login"){
          
          this.email=urlParams.get('email');
          this.password=urlParams.get('code');
          urlParams=new URLSearchParams(window.location.search);
          this.signMeIn();
      }else{
          this.router.navigate(['/login']);
      }
    }

    ionViewLoaded() {
        console.log("Checking if the user is already authenticated. If so, then redirect to the secure site");
        this.userService.isAuthenticated(this);
    }

    async signMeIn() {
        console.log("in onLogin");
        if (this.email == null || this.password == null) {
            this.doAlert("Error", "All fields are required");
            return;
        }
        try{
            const loginRes = await this.authService.login(this.email, this.password, undefined);
            if(loginRes==='newpasswordrequired'){
                this.nav.push(ConfirmRegistrationComponent)
                return;
            }
            await this.httpService.MeteorSubscribe('userData');
            await this.companyDataService.subscribeActiveCompanyPromise()
            .then(()=>this.httpService.privateLoopAction(true))
            this.sharedService.login.emit("logged in");
            const loader = this.loadingCtrl.create({
                content: "Please wait...",
                duration: 2000,
                enableBackdropDismiss: true,
            });
            loader.present();

            if(loginRes==='success'){
                this.nav.setRoot(ProjectHomePage)
            } else 
            this.httpService.refreshSubscriptions()
        }catch(err){
            console.error(err)
            this.doAlert("Error", (err && err.message) || "Incorrect username or password.");
        }
            // this.userService.authenticate(this.email, this.password, this.cognitoCallback as any);
    }

    cognitoCallback(message: string, result: any): void {
        if (message != null) { //error
            this.doAlert("Error", message);
            console.log("result: " + message);
        } else { //success
            console.log("Redirect to Projects Home");
            this.nav.setRoot(ProjectHomePage);
        }
    }

    isLoggedInCallback(message: string, isLoggedIn: boolean) {
        console.log("The user is logged in: " + isLoggedIn);
        if (isLoggedIn) {
            this.eventService.sendLoggedInEvent();
            this.sharedService.login.emit("logged in")
            this.nav.setRoot(ProjectHomePage);
            Session.set('random', Math.random());
        }
    }

    navToRegister() {
        // this.nav.push(RegisterComponent);
    }

    navToForgotPassword() {
        this.nav.push(ForgotPasswordStep1Component);
        this.router.navigate(['/resetPW']);
    }
    firstTimeLogin(){
        this.doAlert('1st Time Login', "Once you are added to a project Logit will send a temporary password to your email address.<br><br>Use that password to login, then you will be prompted to create a new password for your account.")
    }

    doAlert(title: string, message: string) {

        let alert = this.alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: ['OK']
        });
        alert.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/auth/login/login.component.ts